// extracted by mini-css-extract-plugin
export default {"header":"Header_header__d+igc","headerDark":"Header_headerDark__FXFrC","headerLight":"Header_headerLight__pTtvY","icon":"Header_icon__PWZtF"};